<template>
<div class="table-container">
    <div class="table-responsive datatable-vue">
        <b-table show-empty stacked="md" @change="emitChange" :items="state.details" :fields="state.fields">
            <template #cell(id)="row">
                {{ row.index+1 }}
            </template>

            <template #cell(product)="row">
                <select class="form-control" v-model="row.item.product" @change="getItems(row.item.product, row.index)">
                    <option :value="null">Custom Item</option>
                    <option v-for="(q_item, index) in state.quotation_items" :key="index" :value="q_item.id">
                        {{ q_item.name }}
                    </option>
                </select>
                <input v-if="!row.item.product" class="form-control mt-2" type="text" placeholder="Enter custom item" v-model="row.item.item_name">
            </template>
            
            <template #cell(note)="row">
                <input class="form-control" type="text" placeholder="Enter note" v-model="row.item.note">
            </template>

            <template #cell(unit)="row">
                <select class="form-control" v-model="row.item.unit">
                    <option disabled value="">Select unit</option>
                    <option v-for="(unit, index) in state.unitOptions" :key="index" :value="unit">
                        {{ unit.toUpperCase() }}
                    </option>
                </select>
            </template>
            <template #cell(quantity)="row">
                <input @input="calculateAmount(row.item.id)" class="form-control" type="number" placeholder="Enter item quantity" v-model="row.item.quantity">
            </template>
            <template #cell(estimated_unit_cost)="row">
                <input @input="calculateAmount(row.item.id)" class="form-control" type="number" placeholder="Enter unit cost" v-model="row.item.estimated_unit_cost">
            </template>
            <template #cell(estimated_total)="row">
                <div>
                    <input class="form-control" type="number" disabled v-model="row.item.estimated_total">
                </div>
            </template>
            <template #cell(action)="row">
                <button @click="removeItem(row.item.id)" class="btn btn-primary" type="submit">Delete</button>
            </template>
        </b-table>
    </div>
    <div>
        <b-button variant="primary" @click="addItem">Add Item</b-button>
    </div>
</div>
</template>

<script>
import {
    computed,
    defineComponent,
    reactive
} from "vue";

export default defineComponent({
    name: "item-table",

    setup(props, {
        emit
    }) {
        const state = reactive({
     
            unitOptions: ['pcs',
  'kg',
  'litre',
  'box',
  'set',
  'metre',
  'pack',
  'other'],
            currentId: computed(() => state.details.length),
            details: [{
                id: 1,
                product: null,
                item_name: '',
                note: null,
                quantity: null,
                unit: '',
                estimated_unit_cost: null,
                estimated_total: null,
            }, ],
            fields: [{
                    key: 'id',
                    label: '#'
                },
                {
                    key: 'product',
                    label: 'Item',
                    sortable: false
                },
               
                {
                    key: 'note',
                    label: 'Note',
                    sortable: false
                },
                {
                    key: 'unit',
                    label: 'Unit',
                    sortable: false
                },
                {
                    key: 'quantity',
                    label: 'Quantity',
                    sortable: false
                },
                {
                    key: 'estimated_unit_cost',
                    label: 'Unit Price',
                    sortable: false
                },
                {
                    key: 'estimated_total',
                    label: 'Total',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            quotation_items: []
        });

        const calculateAmount = (id) => {
            const item = state.details.find(i => i.id === id);
            if (item) {
                item.estimated_total =
                    (Number(item.quantity) || 0) *
                    (Number(item.estimated_unit_cost) || 0);
            }
            emitChange();
        };

        const getItems = (productId, index) => {
            const item = state.details[index];

            // If custom selected
            if (!productId) {
                Object.assign(item, {
                    product: null,
                    item_name: '',
                    note: '',
                    quantity: null,
                    unit: '',
                    estimated_unit_cost: null,
                    estimated_total: null,
                    notes: ''
                });
                emitChange();
                return;
            }

            // If predefined product
            const product = state.quotation_items.find(
                p => p.id === productId
            );

            if (!product) return;

            Object.assign(item, {
                product: product.id,
                item_name: product.name,
                note: '',
                quantity: 1,
                unit: '',
                estimated_unit_cost: null,
                estimated_total: null,
                notes: ''
            });

            emitChange();
        };

        // Add item
        const addItem = () => {
            state.details.push({
                id: state.currentId + 1,
                product: null,
                item_name: '',
                note: null,
                quantity: null,
                unit: '',
                estimated_unit_cost: null,
                estimated_total: null
            });

        };

        // Remove Item
        const removeItem = (id) => {
            const temp = state.details.filter((item) => item.id !== id);
            state.details = temp;
            calculateId();
            emitChange();
        };

        // Calculate ID
        const calculateId = () => {
            let id = 0;
            state.details.map((item) => {
                id++;
                item.id = id;
                return item;
            });
        };

        // const emitChange = () => {
        //     const formatted = state.details.map(item => {
        
        //         if (item.product) {
        //             return {
        //                 product: item.product,
        //                 quantity: Number(item.quantity) || 0
        //             };
        //         }

        //         return {
        //             product: null,
        //             item_name: item.item_name,
        //             quantity: Number(item.quantity) || 0,
        //             unit: item.unit,
        //             estimated_unit_cost: Number(item.estimated_unit_cost) || 0,
        //             notes: item.notes || ''
        //         };
        //     });

        //     emit("itemsUpdated", formatted);
        // };

        // Emit change
        const emitChange = () => {
            emit("itemsUpdated", state.details);
        };

        return {
            state,
            getItems,
            addItem,
            removeItem,
            calculateAmount,
            emitChange,
        };
    },
    mounted() {
        this.$store.dispatch("inventory/fetchProductWithoutPG").then(result => {
            this.state.quotation_items = result
        })
    }
})
</script>

<style scoped>
.table-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}
</style>
